﻿window.reportMessage = function () {
    var dateTimeErrorMessageLabel = "";

    /*
    * Show / Hide Period Selector
    **/
    function setVisibilityPeriodSelector() {
        var timeinterval_value = parseInt($("#TimeInterval").data("kendoDropDownList").value());

        if (timeinterval_value == timeIntervalEnum.AskedPeriod) {
            $("#periodSelector").show();
        } else {
            $("#periodSelector").hide();
        }
    }

    return {
        /**
        * Initialize
        */
        initialize: function (dateTimeErrorMessage) {
            dateTimeErrorMessageLabel = dateTimeErrorMessage;

            main.setHideDiv("errorMessage", false);
            $("#ReportMessageSearchButtonLoader").hide();
            $("#ReportMessageExportButtonLoader").hide();

            setVisibilityPeriodSelector();
            this.searchAction(null);
        },

        /**
        * setReallyAvailable
        * @param { any } e
        */
        SetReallyAvailable: function (id, element) {

            // Do request
            $.ajax({
                type: "GET",
                url: appsettings.getUrl("ReportMessage/SetReallyAvailable"),
                data: {
                    msgInlogUserId: id,
                    value: element.checked,
                },
                success: function () {

                }
            });

        },

        /**
        * onChange for TimeInterval (show / hide periodSelector)
        * @param { any } e
        */
        onChangeTimeInterval: function (e) {
            setVisibilityPeriodSelector();
        },

        /**
        * Action export (will download excel document according to the selected period)
        * @param { any } DOMelement
        */
        exportAction: function (DOMelement) {
            // Stop the browser from following
            DOMelement.preventDefault();

            main.setHideDiv("errorMessage", false);

            // Show the waiting indicator
            $("#ReportMessageExportButtonLoader").show();

            // Get preference / options selected
            var selectedGroupId = parseInt($("#GroupId").data("kendoDropDownList").value());
            var selectedInterval = parseInt($("#TimeInterval").data("kendoDropDownList").value());

            // Get selection period
            var from = timeinterval.GetBeginPeriodSelection(selectedInterval, "From");
            if (from != null) {
                from = from.toUTCString();
            }

            var to = timeinterval.GetEndPeriodSelection(selectedInterval, "To");
            if (to != null) {
                to = to.toUTCString();
            }

            if (from != null && to != null) {
                // Download File
                $.fileDownload(appsettings.getLocalUrl('ReportMessage/Export?groupId=' + selectedGroupId + "&from=" + from + "&to=" + to))
                    .done(function () { $("#ReportMessageExportButtonLoader").hide(); })
                    .fail(function () { $("#ReportMessageExportButtonLoader").hide(); });
            }
            else {
                // Hide Indicator
                $("#ReportMessageExportButtonLoader").hide();

                // make a message
                main.setHideDiv("errorMessage", true);

                var lblError = $("#errorMessageLabel");
                if (lblError != null && lblError != undefined) {
                    lblError.text(dateTimeErrorMessageLabel);
                }
            }
        },

        /**
        * Action search (will display certain bar charts according to the selected period)
        * @param { any } DOMelement
        */
        searchAction: function (DOMelement) {
            // Indicator
            $("#ReportMessageSearchButtonLoader").show();

            main.setHideDiv("errorMessage", false);

            // get preference / options selected
            var selectedGroupId = parseInt($("#GroupId").data("kendoDropDownList").value());
            var selectedInterval = parseInt($("#TimeInterval").data("kendoDropDownList").value());
            var selectedPeriod = parseInt($("#PeriodPartSelection").data("kendoDropDownList").value());

            // Get selection period
            var From = timeinterval.GetBeginPeriodSelection(selectedInterval, "From");
            if (From != null) {
                From = moment(From.toUTCString()).format("YYYY-MM-DD[T]HH:mm:ss");
            }

            var To = timeinterval.GetEndPeriodSelection(selectedInterval, "To");
            if (To != null) {
                To = moment(To.toUTCString()).format("YYYY-MM-DD[T]HH:mm:ss");
            }

            if (From != null && To != null) {
                // Do request
                $.ajax({
                    type: "GET",
                    url: appsettings.getUrl("ReportMessage/Search"),
                    data: {
                        GroupId: selectedGroupId,
                        From: From,
                        To: To,
                        WorkingDay: selectedPeriod == PeriodPartSelectionEnum.FullPeriod ? null : selectedPeriod
                    },
                    success: function (responseData) {
                        // Get response
                        $("#searchResult").html(responseData);

                        // Hide Indicator
                        $("#ReportMessageSearchButtonLoader").hide();
                    }
                });
            }
            else {
                // Hide Indicator
                $("#ReportMessageSearchButtonLoader").hide();

                // make a message
                main.setHideDiv("errorMessage", true);

                var lblError = $("#errorMessageLabel");
                if (lblError != null && lblError != undefined) {
                    lblError.text(dateTimeErrorMessageLabel);
                }
            }
        },


        showMessageItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            // 
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            viewmode.setViewMode(ModuleActionViewEnum.Show);

            // Do request
            $.ajax({
                type: "GET",
                url: appsettings.getUrl("ReportMessage/MessageDetails"),
                data: {
                    messageInLogId: dataItem.MsgInLogID,
                    incidentLogID: dataItem.IncidentLogID
                },
                success: function (responseData) {
                    // Get response
                    $("#selectedMessage").html(responseData);
                }
            });
        },


        editMessageItem: function (e) {

            // Prevent default behaviour
            e.preventDefault();

            // 
            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            viewmode.setViewMode(ModuleActionViewEnum.Edit);

            // Do request
            $.ajax({
                type: "GET",
                url: appsettings.getUrl("ReportMessage/MessageDetails"),
                data: {
                    messageInLogId: dataItem.MsgInLogID,
                    incidentLogID: dataItem.IncidentLogID
                },
                success: function (responseData) {
                    // Get response
                    $("#selectedMessage").html(responseData);
                }
            });
        },


        /**
        * start / from 
        * 
        * @param { any } DOMelement
        */
        fromChange: function () {
            var start = $("#From").data("kendoDateTimePicker");
            var end = $("#To").data("kendoDateTimePicker");
            var startDate = start.value();
            var endDate = end.value();

            if (startDate) {
                startDate = new Date(startDate);
                startDate.setDate(startDate.getDate());
                end.min(startDate);
            } else if (endDate) {
                start.max(new Date(endDate));
            } else {
                endDate = new Date();
                start.max(endDate);
                end.min(endDate);
            }
        },

        /**
        * end / to
        * 
        * @param { any } DOMelement
        */
        toChange: function () {
            var start = $("#From").data("kendoDateTimePicker");
            var end = $("#To").data("kendoDateTimePicker");
            var endDate = end.value();
            var startDate = start.value();

            if (endDate) {
                endDate = new Date(endDate);
                endDate.setDate(endDate.getDate());
                start.max(endDate);
            } else if (startDate) {
                end.min(new Date(startDate));
            } else {
                endDate = new Date();
                start.max(endDate);
                end.min(endDate);
            }
        },

        /*
         * 
         * @param { any } DOMelement
         */
        initialMessageDetails: function (dtgTitleLabel, inhoudLabel, gridData, showProposalServiceFunction, showIncident) {

            $("#RIncidentKladblokregelsGrid").kendoGrid({
                dataSource: {
                    data: gridData,
                    pageSize: 10,
                },
                height: 500,
                pageable: true,
                columns: [
                    { field: "DTGLocalStr", title: dtgTitleLabel },
                    { field: "Inhoud", title: inhoudLabel }
                ],
            });

            var grid = $("#RIncidentKladblokregelsGrid").data("kendoGrid");
            grid.autoFitColumn(0);

            if (showProposalServiceFunction) {
                $(".RProposalServiceFunction").parent().show();
            } else {
                $(".RProposalServiceFunction").parent().hide();
            }
            
            if (showIncident) {
                $(".PIncident").parent().show();
            } else {
                $(".PIncident").parent().hide();
            }

            if (showIncident) {
                $(".RIncidentKladblokregels").parent().show();
            } else {
                $(".RIncidentKladblokregels").parent().hide();
            }

        }
    }
}();